import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsCliSection = ({ section }) => <DocsLinksSection icon='terminal' section={section} />;

export { DocsCliSection };
